module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page",
    attrs: {
      "id": "page-actueel-thema"
    }
  }, [_c('div', {
    staticClass: "page__content"
  }, [_c('h1', [_vm._v("Hybride docenten zijn een actueel thema")]), _vm._v(" "), _c('div', {
    staticClass: "page__section",
    attrs: {
      "id": "page-actueel-thema__tekort"
    }
  }, [_c('p', [_vm._v("Als deeloplossing voor het lerarentekort")]), _vm._v(" "), _c('div', {
    staticClass: "leraren-tekort"
  }, _vm._l((_vm.nmbTeachers), function(i) {
    return _c('div', {
      staticClass: "flipper"
    }, [_vm._m(0, true)])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "page__section",
    attrs: {
      "id": "page-actueel-thema__carriere"
    }
  }, [_c('p', [_vm._v("Als interessante loopbaankeuze voor leraren die meer willen")]), _vm._v(" "), _c('div', _vm._l((_vm.nmbFootsteps), function(i) {
    return _c('img', {
      staticClass: "page-actueel-thema__footsteps",
      attrs: {
        "src": require("../../assets/icons/footsteps.svg")
      }
    })
  }))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "page-actueel-thema__next-btn"
  }, [_c('page-next-button', {
    on: {
      "click": _vm.nextHandler
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flipper__wrapper"
  }, [_c('div', {
    staticClass: "flipper__face flipper__face--front"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/docent-vrouw-omtrek-100.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flipper__face flipper__face--back"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/docent-vrouw-100.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page__section",
    attrs: {
      "id": "page-actueel-thema__toekomst"
    }
  }, [_c('p', [_vm._v("Als nieuwe invulling van het leraarschap van de toekomst")]), _vm._v(" "), _c('img', {
    staticClass: "page-actueel-thema__rocket",
    attrs: {
      "src": require("../../assets/icons/rocket.svg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-274ac50b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/page-actueel-thema.vue
// module id = 135
// module chunks = 0